import { formatClockTime, formatDayMonth } from "@/lib/dates/relative-time";
import {
  APP_DEFAULT_TIME_ZONE,
  toZonedDateInput,
} from "@/lib/dates/zoned-input";

/** Stable event-local dates and clocks for both attending and attended feed cards. */
export function formatEventAttendanceSchedule(
  startValue: Date | string,
  endValue: Date | string,
): string | null {
  const start = new Date(startValue);
  const end = new Date(endValue);
  const duration = end.getTime() - start.getTime();
  if (!Number.isFinite(duration) || duration <= 0) return null;
  const startDay = formatDayMonth(start, { weekday: true });
  const sameDay =
    toZonedDateInput(start, APP_DEFAULT_TIME_ZONE) ===
    toZonedDateInput(end, APP_DEFAULT_TIME_ZONE);
  const endDay = sameDay ? "" : `${formatDayMonth(end, { weekday: true })} · `;
  return `${startDay} · ${formatClockTime(start)}–${endDay}${formatClockTime(end)}`;
}
